<div class="page-wrapper">
  <app-breadcrumbs></app-breadcrumbs>
  <section class="tsandcs-page">
    <div class="header-background"></div>
    <div class="content-wrapper pos-rel-md" *ngIf="pageData">
      <app-page-retrieval-error
        *ngIf="pageRetrievalError"
      ></app-page-retrieval-error>
      <h1 *ngIf="!pageRetrievalError && pageData.title">
        {{ pageData.title }}
      </h1>
      <div class="separator"></div>
      <div
        class="tsandcs-content"
        *ngIf="!pageRetrievalError && pageData.markdown"
      >
        <app-render-markdown
          [content]="pageData.markdown"
        ></app-render-markdown>
      </div>
    </div>
  </section>
</div>
